@if (weightError) {
  <p class="text-center p-2 text-danger">Weight is over 100%!</p>
}
<div class="cim-datatable-wrapper">
  <table class="exp-table">
    <thead>
      <tr>
        <th class="asset">Name</th>
        <th class="num">Weight</th>
        <th>ISIN</th>
        <th class="num">MCap (M$)</th>
        <th>Earliest price data point</th>
        <th>Asset Class</th>
        <th>Currency</th>
        <th>Sector</th>
      </tr>
    </thead>
    <tbody>
      @for (item of list; track item.id; let index = $index) {
        <tr
          [class.selected-row]="item.markedForDelete"
          [class.etf-border-top]="
            list[index - 1] && list[index - 1].isStock() && item.isFund()
          "
        >
          <td class="asset">
            <mat-checkbox
              [checked]="item.markedForDelete"
              color="primary"
              (change)="onSelect($event, item)"
              >{{
                item.fund_reference_table && item.fund_reference_table.name
                  ? item.fund_reference_table.name
                  : item.company_name
              }}</mat-checkbox
            >
          </td>
          <td class="num">
            <mat-form-field class="cim-input-field" appearance="outline">
              <input
                matInput
                [(ngModel)]="item.weight"
                type="number"
                min="0"
                max="100"
                [disabled]="portfolio.weighting_type !== 'manual'"
                (ngModelChange)="onWeightChange(item)"
              />
              <span matSuffix>%</span>
            </mat-form-field>
          </td>
          <td class="mono">{{ item.isin }}</td>
          <td class="num mono">
            {{ item.market_value_usd | number: "1.0-0" }}
            {{
              item.fund_reference_table.AverageMarketCapital | number: "1.0-0"
            }}
          </td>
          <td class="mono">
            {{
              item.fund_reference_table.FundInceptionDate
                ? item.fund_reference_table.FundInceptionDate
                : item.p_first_date
            }}
          </td>
          <td>{{ item.security_type_equity }}</td>
          <td>
            {{ item.currency?.code || item.currency?.code || item.currency }}
          </td>
          <td>
            {{
              item.sector && item.sector.name
                ? item.sector.name
                : item.fund_reference_table.GlobalCategoryName
                  ? item.fund_reference_table.GlobalCategoryName
                  : item.etf_reference_table.segment_desc
            }}
          </td>
        </tr>
      }
    </tbody>
  </table>
  @if (selected.length) {
    <button
      mat-button
      color="warn"
      (click)="onRemoveClick()"
      class="border-primary text-danger rounded-pill mt-3"
    >
      Remove selected
    </button>
  }
</div>
